import React from "react";
import { MonteurIcon, PersonIcon, UserType } from "../../utils/types";

export const Monteur = ({
  userList,
  bauleiter,
}: {
  userList: UserType[];
  bauleiter?: string;
}) => {
  const bauleiterInList =
    bauleiter != null &&
    bauleiter != "" &&
    userList.some(
      (user) => user.mitarbeiternummer === Number(bauleiter.trim())
    );
  var bauleiterUser: UserType;
  if (bauleiterInList) {
    bauleiterUser = userList.filter(
      (user) => user.mitarbeiternummer === Number(bauleiter.trim())
    )[0];
    userList = userList.filter(
      (user) => user.mitarbeiternummer !== Number(bauleiter.trim())
    );
  }
  return (
    <div className="monteurList">
      {bauleiterInList && (
        <div style={{ display: "flex", alignItems: "center" }}>
          <MonteurIcon />
          <strong>
            {bauleiterUser.last_name}, {bauleiterUser.first_name?.slice(0, 2)}.
            &nbsp;&nbsp;&nbsp;&nbsp;
          </strong>
        </div>
      )}
      {userList.length > 0 && <PersonIcon />}
      {userList
        .sort((a, b) => a.last_name.localeCompare(b.last_name))
        .map(
          (monteur, index) =>
            (monteur.first_name != null || monteur.last_name != null) &&
            (monteur.first_name != "" || monteur.last_name != "") && (
              <strong key={index}>
                {monteur.last_name}, {monteur.first_name?.slice(0, 2)}.
                &nbsp;&nbsp;&nbsp;&nbsp;
              </strong>
            )
        )}
    </div>
  );
};
